import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAdminUser, IAdminUsersState } from '../../types/store';
import { IGetAdminUsersResponse } from '../../types/api/response/adminusersresponse';

const initialState: IAdminUsersState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const adminUsersSlice = createSlice({
  name: 'adminUsersSlice',
  initialState,
  reducers: {
    setAdminUsers: (state, action: PayloadAction<IGetAdminUsersResponse>) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    addUser: (state, action: PayloadAction<IAdminUser>) => {
      state.content.push(action.payload);
      state.page.totalElements++;
    },
    updateAdminUser: (state, action: PayloadAction<IAdminUser>) => {
      const idx = state.content.findIndex((u) => u.id === action.payload.id);
      if (idx > -1) state.content[idx] = action.payload;
    },
    deleteAdminUser: (state, action: PayloadAction<number>) => {
      state.content = state.content.filter((u) => u.id !== action.payload);
      state.page.totalElements--;
    },
    toggleAdminUserEnabled: (state, action: PayloadAction<{ id: number; enabled: boolean }>) => {
      const user = state.content.find((u) => u.id === action.payload.id);
      if (user) user.enabled = action.payload.enabled;
    },
  },
});

export const { setAdminUsers, addUser, updateAdminUser, deleteAdminUser, toggleAdminUserEnabled } =
  adminUsersSlice.actions;

export default adminUsersSlice.reducer;
